export const deliveryMethods = {
    1: "پست پیشتاز",
    2: "پست معمولی",
    3: "پیک"
}